var map = {
	"./census-form-example.png": 27475,
	"./csv.png": 31826,
	"./doc.png": 25392,
	"./excel.png": 47087,
	"./img.png": 47427,
	"./logo-full-color-medium.png": 42821,
	"./logo-medium.png": 40109,
	"./logo-watermark-color.png": 90558,
	"./logo-watermark-white.png": 172,
	"./logo-wordmark-color.png": 76453,
	"./numbers.png": 73940,
	"./pdf.png": 72752,
	"./void-cheque.png": 74208,
	"./xls.png": 85837
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73096;